import { testId } from '../../utils';
import { Iconography } from './Iconography';
import clsx from 'clsx';
import React from 'react';

export enum ButtonVariants {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  disabled?: boolean;
  asChild?: boolean;
  variant?: ButtonVariants;
  size?: 'sm';
  'data-testid': string;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant = ButtonVariants.Primary,
      size,
      loading,
      disabled = false,
      'data-testid': dataTestId,
      ...props
    },
    ref,
  ) => {
    const isDisabled = loading || disabled;
    const sizeClass = size === 'sm' ? 'min-w-32' : 'w-full';
    return (
      <button
        className={clsx(
          'font-semibold transition-colors disabled:pointer-events-none disabled:opacity-50 rounded',
          'relative h-12 px-8 font-semibold transition-colors rounded focus:ring focus:ring-offset-2',
          sizeClass,
          className,
          {
            'text-blue-active bg-white border border-solid border-blue-active hover:bg-gray-lightest':
              variant === ButtonVariants.Secondary,
            'text-white bg-blue-active border border-transparent hover:bg-blue-dark focus:bg-blue-dark hover:border-blue-active':
              variant === ButtonVariants.Primary,
            'disabled:text-gray disabled:bg-gray-light disabled:opacity-100':
              isDisabled,
          },
        )}
        ref={ref}
        disabled={isDisabled}
        {...testId(dataTestId)}
        {...props}
      >
        {loading ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <Iconography
              variant="progress_activity"
              className="animate-spin "
            />
          </div>
        ) : (
          props.children
        )}
      </button>
    );
  },
);
Button.displayName = 'Button';
